import React from 'react';
import classNames from 'classnames';
import { Switch } from 'antd';
import { useSectionGuidanceVisibility } from '../../contexts/SectionGuidanceVisibilityContext';
import './SectionGuidanceToggle.scss';

export default function SectionGuidanceToggle({ className, label = 'Guidance' }) {
  const ctx = useSectionGuidanceVisibility();
  if (!ctx) return null;

  const { isGuidanceVisible, setIsGuidanceVisible } = ctx;

  return (
    <div className={classNames('section-guidance-toggle', className)}>
      <Switch
        size="small"
        checked={isGuidanceVisible}
        onChange={setIsGuidanceVisible}
        aria-label={label === 'Guidance' ? 'Show section guidance' : `Show ${label}`}
      />
      <span className="section-guidance-toggle__label">{label}</span>
    </div>
  );
}
